import AddToGroupModal from "./AddToGroupModal"

export default  AddToGroupModal;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/AddToGroup/AddToGroupModal/index.js